export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/chevron-left-gray.2a4956d0.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};